import { RoundIntegrityWatcher } from '../../../logger/RoundIntegrityWatcher';
import type { CoreStoreType } from '../../../store/CoreStore';
import { betActions } from '../../../store/slices/bets/slice';
import type { AcceptedBet, BetType } from '../../../store/slices/bets/types';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

import { BaseGameCommunicationBetProcessor } from './BaseGameCommunicationBetProcessor';

export class GameCommunicationBetProcessor
  extends BaseGameCommunicationBetProcessor
  implements IGameCommunicationProcessor
{
  messageName = 'bet';

  // TODO: maybe I should be renamed to something like 'GameCommunicationBetRestorationProcessor'?

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    RoundIntegrityWatcher.setHadBets();

    const { amount, betcode } = this.extractMessageData(message);

    if (store.getState().gameState.isLoadedInActiveRound) {
      const acceptedBetRestored: AcceptedBet = {
        amount,
        betcode,
        errorCode: 0,
      };

      const bet: BetType = {
        betSpots: {
          [betcode]: { value: amount },
        },
      };

      this.processActiveRound(store, acceptedBetRestored, bet);
    } else {
      this.processSubsequentRounds(store, betcode);
    }
  }

  protected extractMessageData(message: GameCommunicationMessageType): { amount: number; betcode: number } {
    return {
      amount: Number(message.amount),
      betcode: Number(message.betcode),
    };
  }

  protected processActiveRound(store: CoreStoreType, acceptedBet: AcceptedBet, bet: BetType): void {
    const tableId = store.getState().config.session?.tableId || '';
    store.dispatch(betActions.pushAcceptedBet(acceptedBet));
    store.dispatch(betActions.updateBetStackHead(bet));
    store.dispatch(betActions.saveLastBets({ tableId }));
  }

  private processSubsequentRounds(store: CoreStoreType, betcode: number): void {
    store.dispatch(betActions.updateAcceptedBet(betcode));
    this.updateGameStatus(store);
  }
}
